var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderReviewRecieved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MC/Order review recieved",
    clipPath: "url(#clip0_13166_61807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009467"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1212",
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 894",
    d: "M4 12C4 16.4183 7.58172 20 12 20C14.2474 20 16.2783 19.0733 17.7315 17.5812C19.1353 16.1399 20 14.1709 20 12C20 7.58172 16.4183 4 12 4C9.80628 4 7.81879 4.88297 6.37354 6.31291C4.90797 7.76295 4 9.77544 4 12Z",
    fill: "#82BD54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 8L10.8834 15.1175C10.4844 15.5818 9.7656 15.5818 9.36658 15.1175L7 12.3636",
    stroke: "white",
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13166_61807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderReviewRecieved);
export default __webpack_public_path__ + "static/media/Order-review-recieved.778e3bee2c5c9986d07bcc307b1c4a94.svg";
export { ForwardRef as ReactComponent };